import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

export function render(_ctx, _cache) {
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_form = _resolveComponent("v-form")

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(_ctx.submit, ["prevent"]),
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_text_field, {
          variant: "outlined",
          density: "compact",
          "validate-on": "blur",
          class: "shrink security-code-panel mr-4",
          label: _ctx.secuityCodeData.label,
          placeholder: "Enter security code",
          rules: _ctx.secuityCodeData.rules,
          modelValue: _ctx.twoFactorPassword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.twoFactorPassword) = $event))
        }, null, 8, ["label", "rules", "modelValue"]),
        _createVNode(_component_v_btn, {
          class: "submit-button",
          type: "submit",
          variant: "flat",
          tile: "",
          color: "primary",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Confirm ", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}